import React from 'react'
import { SVGIconProps } from '../types'
const SvgSend = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M2.01 21 23 12 2.01 3 2 10l15 2-15 2z" />
  </svg>
)
export default SvgSend
